import { app } from '../../../app';
import { lazyLoad } from '../../../lib/lazy-load';
import { userFromDto } from './administrators.dto';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.administrators', {
        url: '/administrators',
        redirectTo: 'company.administrators.list',
        component: 'companyAdministrators',
        resolve: {
            administrators,
            applications$,
            applicationsAndTypes$,
            appTypes$,
            groups$,
        }
    })
}

/** @ngInject */
function administrators($filter, account, companyId, RoleResource) {
    return RoleResource.getAllCompanyUsersWithRole(companyId)
        .then(users => users.map(userFromDto))
        .then(users => users.map(user => ({
            ...user, order: user.order + (account.login === user.saaspassId ? 1 : 0)
        })))
        .then(users => $filter('orderBy')(users, 'order', true))
}

/** @ngInject */
function applications$($filter, applicationsAndTypes$) {
    return applicationsAndTypes$
        .map(({applications}) => applications)
        .map(applications => applications.map(a => ({...a, name: a.applicationName})))
        .map(applications => $filter('orderBy')(applications, 'name'))
}

/** @ngInject */
function applicationsAndTypes$(companyId, RoleResource) {
    return lazyLoad(() => RoleResource.getApplicationsAndTypes(companyId))
}

/** @ngInject */
function appTypes$($filter, applicationsAndTypes$) {
    return applicationsAndTypes$
        .map(({types}) => types)
        .map(types => types.map(t => ({id: `${t.applicationTypeId}`, name: t.applicationTypeDisplayName})))
        .map(types => $filter('orderBy')(types, 'name'))
}

/** @ngInject */
function groups$($filter, companyId, GroupsResource) {
    return lazyLoad(() => GroupsResource.getAllCompanyGroups(companyId))
        .map(groups => groups.map(g => ({...g, name: g.groupName})))
        .map(groups => $filter('orderBy')(groups, 'name'))
}



// WEBPACK FOOTER //
// ./src/portal/states/company/administrators/administrators.state.js